module.exports = __webpack_public_path__ + "img/12.8495c20f.jpg";